<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="12" fill="#108CFF" />
  <path
    d="M10.9728 17.8416V9.3408H13.0752V17.8416H10.9728ZM11.16 8.088C10.92 7.848 10.8 7.56 10.8 7.224C10.8 6.888 10.92 6.6 11.16 6.36C11.4 6.12 11.688 6 12.024 6C12.36 6 12.648 6.12 12.888 6.36C13.128 6.6 13.248 6.888 13.248 7.224C13.248 7.56 13.128 7.848 12.888 8.088C12.648 8.328 12.36 8.448 12.024 8.448C11.688 8.448 11.4 8.328 11.16 8.088Z"
    fill="white" />
</svg>